import {
  createRole,
  getRole,
  getRoleList,
  updateRole,
  deleteRole,
} from '@/api/role'

export default {
  CREATE_ROLE(_, data) {
    return createRole(data)
  },
  FETCH_ROLE({ commit }, params) {
    return getRole(params)
      .then(res => {
        commit('SET_ROLE', res.data)
      })
  },
  FETCH_ROLE_LIST({ commit }, params) {
    return getRoleList(params)
      .then(res => {
        commit('SET_ROLE_LIST', res.data)
      })
  },
  UPDATE_ROLE(_, data) {
    return updateRole(data)
  },

  DELETE_ROLE(_, id) {
    return deleteRole(id)
  },
}
